module.exports = "/assets/30c425355a6bac26d6b7972d0d29e25f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GI.png
// module id = 1406
// module chunks = 0